import { render, staticRenderFns } from "./ConfigDocumentList.vue?vue&type=template&id=d935ea82&scoped=true&"
import script from "./ConfigDocumentList.vue?vue&type=script&lang=js&"
export * from "./ConfigDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDocumentList.vue?vue&type=style&index=0&id=d935ea82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d935ea82",
  null
  
)

export default component.exports